module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAt0lEQVQ4T6WSsQ0CMQxF/5uHJbghjoqOjoqOEpCo6Kjo6GjYAZEh2McopwRFKJwDpEkU+T/b30aSzGwab+8AIcX3knpgRvowTyxpB2zNLIqvkubA5QUAhvfYKcQL4BxjmwGFeAmccqImQCFeAceyShdQiNfAIXl2T56EFkAMvgH7nNnM2gE1U0cBZpZHGoDua4A3StcDbyvjNra2UCumcwF/t/AzQFLV8Q/AzfsiPSRNWrIXMYMfT6gDoRH/5jDVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edit.png
// module id = KzIr
// module chunks = 71